App.SettingsInterfaceController = Em.Controller.extend

  env:      Em.inject.service('environment')

  soundNotifications: localStorage.getItem('soundNotifications') == 'true'
  integrationsSettings: localStorage.getItem('integrationsSettings') == 'true'
  mapScrollOnMouseWheel: localStorage.getItem('mapScrollOnMouseWheel') == 'true'
  lowPerformanceMode: localStorage.getItem('lowPerformanceMode') == 'true'
  hideMapInOrders: localStorage.getItem('hideMapInOrders') == 'true'
  hideLaterOrdersOnMap: localStorage.getItem('hideLaterOrdersOnMap') == 'true'
  hideUnauthorizedCouriers: localStorage.getItem('hideUnauthorizedCouriers') == 'true'
  soundNotificationsVerbose: localStorage.getItem('soundNotificationsVerbose') == 'true'
  soundNotificationsRepeat: localStorage.getItem('soundNotificationsRepeat') == 'true'
  hideOrderNotifications: localStorage.getItem('hideOrderNotifications') == 'true'
  hidePickupOrdersAtNow: localStorage.getItem('hidePickupOrdersAtNow') == 'true'
  showButtonForOptionalModifiers: localStorage.getItem('showButtonForOptionalModifiers') == 'true'
  showDishPhotoInOrderCard: localStorage.getItem('showDishPhotoInOrderCard') == 'true'
  monitorCheckInterval: if parseInt(localStorage.getItem('monitorCheckInterval')) > 0 then parseInt(localStorage.getItem('monitorCheckInterval')) else 60;
  notificationDuration: if parseInt(localStorage.getItem('notificationDuration')) > 0 then parseInt(localStorage.getItem('notificationDuration')) else 15;
  notificationsRepeatSoundInterval: if parseInt(localStorage.getItem('notificationsRepeatSoundInterval')) > 0 then parseInt(localStorage.getItem('notificationsRepeatSoundInterval')) else 1;
  showAssignedCourierInOrderCard: localStorage.getItem('showAssignedCourierInOrderCard') == 'true'


  currentLanguage: 'en'


  initLanguages: (->
    languagesArray = Em.A()
    languagesArray.pushObject(Em.Object.create( name: 'English',    value: 'en'))
    languagesArray.pushObject(Em.Object.create( name: 'Türk',       value: 'tr'))
    languagesArray.pushObject(Em.Object.create( name: 'Русский',    value: 'ru'))
    languagesArray.pushObject(Em.Object.create( name: 'Español',    value: 'es'))
    # languagesArray.pushObject(Em.Object.create( name: 'Українська', value: 'uk'))
    @set('languages', languagesArray)

    ll = languagesArray.filter((l) => l.value == Em.I18n.locale)[0]

    @set 'currentLanguage', ll
  ).on('init')

  setLanguage: (->
    locale = @get('currentLanguage').value
    localStorage.setItem('interfaceLocale', locale)
    Em.I18n.locale = locale
    Em.I18n.translations = Em.I18n.locales[ locale ]
    $.each Ember.View.views, (index, view) ->
      view.rerender();
  ).observes('currentLanguage')



  onMonitorCheckIntervalChange: (->
    localStorage.setItem('monitorCheckInterval', @get('monitorCheckInterval'))
  ).observes('monitorCheckInterval')

  onNotificationDurationChange: (->
    localStorage.setItem('notificationDuration', @get('notificationDuration'))
  ).observes('notificationDuration')

  onmapScrollOnMouseWheelChange: (->
    localStorage.setItem('mapScrollOnMouseWheel', @get('mapScrollOnMouseWheel'))
  ).observes('mapScrollOnMouseWheel')

  onHidePickupOrdersAtNowChange: (->
    localStorage.setItem('hidePickupOrdersAtNow', @get('hidePickupOrdersAtNow'))
  ).observes('hidePickupOrdersAtNow')

  onShowButtonForOptionalModifiersChange: (->
    localStorage.setItem('showButtonForOptionalModifiers', @get('showButtonForOptionalModifiers'))
  ).observes('showButtonForOptionalModifiers')

  onShowDishPhotoInOrderCardChange: (->
    localStorage.setItem('showDishPhotoInOrderCard', @get('showDishPhotoInOrderCard'))
  ).observes('showDishPhotoInOrderCard')

  onShowAssignedCourierInOrderCardChange: (->
    localStorage.setItem('showAssignedCourierInOrderCard', @get('showAssignedCourierInOrderCard'))
  ).observes('showAssignedCourierInOrderCard')

  onSoundNotificationsChange: (->
    localStorage.setItem('soundNotifications', @get('soundNotifications'))
  ).observes('soundNotifications')

  onIntegrationsSettingsChange: (->
    localStorage.setItem('integrationsSettings', @get('integrationsSettings'))
  ).observes('integrationsSettings')

  onLowPerformanceModeChange: (->
    localStorage.setItem('lowPerformanceMode', @get('lowPerformanceMode'))
    if !@get('lowPerformanceMode')
      localStorage.setItem('hideMapInOrders', false)
  ).observes('lowPerformanceMode', 'hideMapInOrders')

  onHideMapInOrders: (->
    localStorage.setItem('hideMapInOrders', @get('hideMapInOrders'))
  ).observes('hideMapInOrders')

  onHideLaterOrdersOnMapChange: (->
    localStorage.setItem('hideLaterOrdersOnMap', @get('hideLaterOrdersOnMap'))
  ).observes('hideLaterOrdersOnMap')

  onHideUnauthorizedCouriersChange: (->
    localStorage.setItem('hideUnauthorizedCouriers', @get('hideUnauthorizedCouriers'))
  ).observes('hideUnauthorizedCouriers')

  onHideOrderNotificationsChange: (->
    localStorage.setItem('hideOrderNotifications', @get('hideOrderNotifications'))
  ).observes('hideOrderNotifications')

  onSoundNotificationsVerboseChange: (->
    localStorage.setItem('soundNotificationsVerbose', @get('soundNotificationsVerbose'))
  ).observes('soundNotificationsVerbose')

  onSoundNotificationsRepeat: (->
    localStorage.setItem('soundNotificationsRepeat', @get('soundNotificationsRepeat'))
  ).observes('soundNotificationsRepeat')

  onNotificationsRepeatSoundInterval: (->
    localStorage.setItem('notificationsRepeatSoundInterval', @get('notificationsRepeatSoundInterval'))
  ).observes('notificationsRepeatSoundInterval')


  actions:

    discartChanges: ->
      false
